const BASE_URL = 'https://mts-link.ru'

/** Fallback: already in static/ (not generated). */
const DEFAULT_OG_IMAGE = `${BASE_URL}/img/og-image.jpg`

/**
 * Existing page visuals for OG cards (webpack assets → /_nuxt/…).
 * Key = pathname with trailing slash.
 */
const OG_IMAGES_BY_PATH = {
  '/': require('~/assets/img/main/main-promo-bg.png'),
  '/products/webinar/': require('~/assets/img/products-webinars/webinars--promo/promo-bg.jpg'),
  '/products/meetings/': require('~/assets/img/products-meetings/meetings--promo/promo-bg.jpg'),
  '/products/messenger/': require('~/assets/img/products-messenger/promo-new/promo-image.png'),
  '/products/westudy/': require('~/assets/new-design/img/products/westudy/promo/promo-bg.jpg'),
  '/products/comdi/': require('~/assets/img/products-comdi/img_bg.jpg'),
  '/products/on-premise/': require('~/assets/new-design/img/products/on-premise/promo/promo-bg.jpg'),
  '/products/cloud-storage-and-docs/': require('~/assets/new-design/img/products/disk-and-document/promo/promo-bg.jpg'),
  '/products/corporate-mail-and-calendar/': require('~/assets/new-design/img/products/email-and-calendar/promo/promo-bg.jpg'),
  '/products/task-management/': require('~/assets/img/products-task-management/task-management--promo/promo-bg.jpg'),
  '/metodichka/': require('~/assets/new-design/img/metodichka/promo/promo-img.png'),
  '/about_service/': require('~/assets/new-design/img/about-service/promo/promo-bg.jpg'),
  '/contacts/': require('~/assets/img/contacts/contacts--promo.jpg'),
  '/functions/': require('~/assets/img/functions/product-detail-promo-bg.jpg'),
  '/faq_and_support/': require('~/assets/img/faq_and_support/support.jpg'),
  '/faq_and_support/system_test/': require('~/assets/new-design/img/faq-and-support/system-test/promo/promo-bg.png'),
  '/task/obuchenie_studentov/': require('~/assets/new-design/img/task/education/promo/promo.png'),
  '/task/healthcare/': require('~/assets/img/task/healthcare/promo.jpg'),
  '/task/med/': require('~/assets/img/task/med/promo.jpg'),
  '/task/nmo/': require('~/assets/img/task/nmo/promo.jpg'),
  '/task/ouz/': require('~/assets/img/task/ouz/promo.jpg'),
  '/task/pharma/': require('~/assets/img/task/pharma/promo.jpg'),
  '/application/': require('~/assets/new-design/img/application/banner.png'),
  '/updates/': require('~/assets/new-design/img/updates/index/sidebar-bg.jpg'),
  '/tariffs/': require('~/assets/img/content-page-promo-bg.jpg'),
  '/sitemap/': require('~/assets/img/content-page-promo-bg.jpg'),
  '/signup/': require('~/assets/img/content-page-promo-bg.jpg'),
  '/user/': require('~/assets/img/content-page-promo-bg.jpg'),
  '/user/organizer/': require('~/assets/img/content-page-promo-bg.jpg'),
  '/user/participant/': require('~/assets/img/content-page-promo-bg.jpg'),
  '/user/demo/': require('~/assets/img/content-page-promo-bg.jpg'),
  '/audioconference/': require('~/assets/img/content-page-promo-bg.jpg'),
  '/webconference/': require('~/assets/img/content-page-promo-bg.jpg'),
  '/videoconference/': require('~/assets/img/content-page-promo-bg.jpg'),
}

function normalizePath(path) {
  if (!path) return '/'
  if (path.startsWith('http')) {
    try {
      path = new URL(path).pathname
    } catch (e) {
      return '/'
    }
  }
  if (!path.startsWith('/')) path = `/${path}`
  if (path.length > 1 && !path.endsWith('/')) path = `${path}/`
  return path
}

function toAbsoluteUrl(image) {
  if (!image) return DEFAULT_OG_IMAGE
  if (image.startsWith('http')) return image
  return `${BASE_URL}${image.startsWith('/') ? image : `/${image}`}`
}

function resolveOgImage(path, image) {
  if (image) return toAbsoluteUrl(image)

  const normalized = normalizePath(path)
  if (OG_IMAGES_BY_PATH[normalized]) {
    return toAbsoluteUrl(OG_IMAGES_BY_PATH[normalized])
  }

  // /tariffs/{item}/{period}/ → tariffs promo
  if (normalized.startsWith('/tariffs/') && normalized !== '/tariffs/') {
    return toAbsoluteUrl(OG_IMAGES_BY_PATH['/tariffs/'])
  }

  return DEFAULT_OG_IMAGE
}

/**
 * Open Graph meta tags for Nuxt head().
 * Always use `property` (not `name`) — crawlers ignore name-based og tags.
 *
 * @param {Object} options
 * @param {string} options.title
 * @param {string} options.description
 * @param {string} options.path — pathname starting with `/`, or absolute URL
 * @param {string} [options.image] — optional override (absolute URL or site path)
 * @param {string} [options.type='website']
 * @returns {Array<Object>}
 */
export function getOpenGraphMeta({
  title,
  description,
  path,
  image,
  type = 'website',
}) {
  if (!title || !description || !path) {
    return []
  }

  const url = path.startsWith('http')
    ? path
    : `${BASE_URL}${normalizePath(path)}`
  const imageUrl = resolveOgImage(path, image)

  return [
    { hid: 'og:type', property: 'og:type', content: type },
    { hid: 'og:url', property: 'og:url', content: url },
    { hid: 'og:title', property: 'og:title', content: title },
    {
      hid: 'og:description',
      property: 'og:description',
      content: description,
    },
    { hid: 'og:image', property: 'og:image', content: imageUrl },
    { hid: 'og:site_name', property: 'og:site_name', content: 'МТС Линк' },
    { hid: 'og:locale', property: 'og:locale', content: 'ru_RU' },
  ]
}

export { BASE_URL, DEFAULT_OG_IMAGE }
